import { UseFormRegister, FieldErrors } from "react-hook-form";
import {
    Typography,
    BaseTextFieldProps,
    FormControl,
    Input,
    Tooltip
  } from "@material-ui/core";
  
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
//import {Box,} from "@dna/react";
import { sharedUserInfoStyles } from "../Styles/sharedUserInfoStyles";
import { makeStyles } from "@material-ui/core";

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.white,
        "&::before": {
            border: "1px solid #c6c6c6",
            backgroundColor: "#fff",
            boxSizing: "border-box"
        }
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: "none",
        fontSize:'inherit',
        border:"1px solid #c6c6c6",
        paddingTop:10
    },
    iconPos:{
        paddingTop:10
    }
  }));

type TextFieldComponentProps = {
    id: string;
    helpText:string;
    label: string;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
} & BaseTextFieldProps;

export const TextFieldWithHelperComponent = ({
  id,
  label,
  helpText,
  register,
  errors,
  ...rest
}: TextFieldComponentProps) => {
  const classes = sharedUserInfoStyles();
  const toolTipclasses = useStylesBootstrap();
  return (
    <>
    <FormControl  margin="normal" variant="standard" fullWidth >
       <div style={{ height:22}}>
            <div style ={{margin:0, paddingLeft:0, float:"left"}} className={classes.textLabel}>{label} </div> 
            <div style ={{ float:"left", paddingLeft:6}}>
                <Tooltip title={helpText} classes={toolTipclasses}  arrow>
                    <InfoOutlinedIcon/>
                </Tooltip>
            </div> 
        </div>
       <Input  {...register(id)} />
     </FormControl>
     <Typography variant="inherit" className={classes.errorLabel}>
        {errors[id]?.message}
      </Typography>
    </>
  );
};
